import { useGetTradeInEligibility } from "@jti/rest-api";
import { useUser } from "@jti/rip";
import { useConfig } from "@jti/ui/providers/useConfig";
export const useTradeInDisabled = (isTradeIn) => {
    const { tradeInOnlyForRegistered } = useConfig();
    const { userData } = useUser();
    const getEligibilityQuery = useGetTradeInEligibility(isTradeIn);
    const notDisabledReturn = { status: "not-disabled" };
    if (!isTradeIn) {
        return notDisabledReturn;
    }
    if (getEligibilityQuery.isLoading) {
        return { status: "loading" };
    }
    if (getEligibilityQuery.isError) {
        return { status: "error" };
    }
    const baseDisabledPayload = { status: "disabled" };
    if (!getEligibilityQuery.data?.isEligible) {
        return { ...baseDisabledPayload, cause: "not-eligible" };
    }
    if (tradeInOnlyForRegistered && !userData?.is_device_registered) {
        return { ...baseDisabledPayload, cause: "missing-registered-device" };
    }
    return notDisabledReturn;
};
//# sourceMappingURL=useTradeInDisabled.js.map